/* eslint-disable @typescript-eslint/no-unused-vars */
import { IOperacao, IOperacaoListagem } from '../../../../../../../interfaces/IOperacaoPLG';
import { BrButton } from '@govbr-ds/react-components';
import styles from './lavraGarimpeiraTab.module.scss';
import { useContext } from 'react';
import { DiefCfemContext } from '../../../../../../../contexts/DiefCfemContext';
import { useBackEndRequests } from '../../../../../lib/backEndRequests';
import { OperacaoTable } from './operacaoTable/operacaoTable';

interface IHeader {
  field: string;
  label: string;
}

interface IProps {
  setEdicaoOperacao: React.Dispatch<React.SetStateAction<IOperacao | undefined>>;
  setNovaOperacaoPLG: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LavraGarimpeiraTab = ({ setEdicaoOperacao, setNovaOperacaoPLG }: IProps) => {
  const context = useContext(DiefCfemContext);
  const declaracaoTitularArrendatario = context?.declaracaoTitularArrendatario;
  const idDeclaracao = declaracaoTitularArrendatario?.id;

  const headers: IHeader[] = [
    { field: 'id', label: 'ID Operação' },
    { field: 'substancia', label: 'Substância' },
    { field: 'municipio', label: 'Município/UF' },
    { field: 'tipoOperacao', label: 'Tipo da Operação' },
    {
      field: 'houveFatoGerador',
      label: 'Houve Fato Gerador da CFEM?',
    },
    {
      field: 'houveProducao',
      label: 'Houve Produção de Bem Mineral?',
    },
    { field: 'valorTotal', label: 'Valor Venda/Operação' },
    { field: 'acoes', label: 'Ações' },
  ];

  const data: IOperacaoListagem[] = [];

  const isLoading = false;

  return (
    <div className={styles.customTab}>
      <div className={styles.buttonContainer}>
        <BrButton secondary onClick={() => setNovaOperacaoPLG(true)}>
          <i className={`fas fa-plus fa-md  ${styles.columnIcon}`} />
          <span> Adicionar Operação</span>
        </BrButton>
      </div>

      <div className={styles.operacoesTable}>
        <OperacaoTable
          idDeclaracao={idDeclaracao || ''}
          headers={headers}
          isLoading={isLoading}
          setEdicaoOperacao={setEdicaoOperacao}
          setNovaOperacaoPLG={setNovaOperacaoPLG}
        />
      </div>
    </div>
  );
};
